import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { login } from "../api/api";
import { v4 as uuidv4 } from "uuid";
import Logo from "../../assets/images/Logo.png";
import "../CounsellorAllPages/CounsellorLogin.css";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const CounsellorLogin = () => {
  const navigate = useNavigate();
  //   const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [deviceToken, setDeviceToken] = useState("");
  const [jwtToken, setJwtToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  useEffect(() => {
    const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
    setJwtToken(generatedToken);
    localStorage.setItem("jwtToken", generatedToken);
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const response = await login(values);
      console.log("response_login", response);
      if (response?.success === true) {
        localStorage.setItem("currentUser", JSON.stringify(response?.data));
        const user = response?.data;

        if (user.approve_reject === "pending") {
          switch (user.profile_completion_status) {
            case "emailvarification":
              navigate("/CounsellorEmailVerification");
              break;
            case "uploadDocument":
              navigate("/CounsellorDoucmentation");
              break;
            case "CounsellorImageUpload":
              navigate("/CounsellorImageUpload");
              break;
            case "CounsellorFinalSubmission":
              navigate("/CounsellorFinalSubmission");
              break;
            case "CounsellorSidebar":
              alert(response.message);
              if (user.approve_reject === "approved") {
                navigate("/CounsellorTab");
              } else {
                navigate("/CounsellorFinalSubmission");
              }
              break;
            default:
              alert(response.message);
              navigate("/CounsellorSidebar");
          }
        } else if (user.approve_reject === "rejected") {
          alert(response.message);
          navigate("/CounsellorDoucmentation");
        } else {
          alert(response.message);
          if (
            user.approve_reject === "approved" &&
            user.profile_completion_status === "Tab"
          ) {
            navigate("/CounsellorSidebar");
          }
        }
      } else {
        alert(response?.message);
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        token: deviceToken,
        jwtsecret: jwtToken,
        type: "counsellor",
        registering_from: "web",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        values,
        errors,
        touched,
      }) => (
        <div className="login-container">
          <div className="login-logo">
            <img src={Logo} alt="Logo" className="login-logo" />
          </div>
          <h2 className="login-title">Please Login As a Counsellor</h2>
          <div className="form-wrapper">
            <div className="input-wrapper">
              <i className="fas fa-envelope icon"></i>
              <input
                type="email"
                placeholder="Email"
                className="input-field"
                onChange={(e) =>
                  handleChange("email")(e.target.value.toLowerCase())
                }
                onBlur={handleBlur("email")}
                value={values.email}
              />
            </div>
            {touched.email && errors.email && (
              <p className="error-text">{errors.email}</p>
            )}

            <div className="input-wrapper">
              <i className="fas fa-lock icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="input-field"
                onChange={handleChange("password")}
                onBlur={handleBlur("password")}
                value={values.password}
              />
              <button
                onClick={togglePasswordVisibility}
                type="button"
                className="toggle-password-btn"
              >
                <i
                  className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                ></i>
              </button>
            </div>
            {touched.password && errors.password && (
              <p className="error-text">{errors.password}</p>
            )}

            <button onClick={handleSubmit} className="submit-btn">
              {isLoading ? "Loading..." : "Sign In"}
            </button>

            <div className="link-container">
              {/* <p
                onClick={() => navigate("/CounsellorForgotPassword")}
                className="link-btn"
              >
                Forgot Password?
              </p>
              <p className="sub-text">Click Here!</p> */}
              <p className="link-btn">Forgot Password?</p>{" "}
              <p
                className="sub-text"
                onClick={() => navigate("/CounsellorForgotPassword")}
              >
                Click Here!
              </p>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default CounsellorLogin;
